import React, { useState, useEffect } from "react";

function ClientReviewVisveshBalasubramanian() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const reviews = [
    {
      name: "- SathyKalyan",
      location: "Holly Springs, NC",
      contentHeading:
        "Exceptional Support and Expertise for First-Time Homebuyers ",
      content:
        "As a first-time homebuyer, I couldn’t have asked for a better experience than working with Visvesh Balasubramanian. Visvesh guided me through the entire mortgage process with patience, clarity, and professionalism. He took the time to explain every step, ensuring I fully understood my options and felt confident in my decisions. His responsiveness and attention to detail were outstanding, making what could have been an overwhelming process feel smooth and manageable. I’m truly grateful for his expertise and support in helping me achieve this milestone. I highly recommend Visvesh Balasubramanian to anyone, especially first-time buyers, looking for a knowledgeable and trustworthy mortgage professional.",
    },
    {
      name: "- Karthik ",
      location: "Apex, NC",
      contentHeading: "Excellent Job on my refinancing for 2nd time ",
      content:
        "I recently worked with Visvesh on refinancing my mortgage, and I couldn’t be happier with the service I received. From the very beginning, he was transparent and straightforward about the entire process, which made me feel confident and at ease. He explained all the details, walked me through the options, and ensured I understood each step before making any decisions. The communication was excellent, and Visvesh was always available to answer my questions promptly. I truly appreciated his honesty and professionalism, which made the whole experience stress-free. If you’re looking for a mortgage broker who is reliable, transparent, and dedicated to getting the best results for you, I highly recommend Visvesh. Feel free to personalize the details further to match your experience!",
    },
    {
      name: "- Venkat Cherukuru",
      location: "Sterling, VA",
      contentHeading:
        "Exceptional Service and Smooth Mortgage Refinance Experience with Visvesh ",
      content:
        "I recently completed a mortgage refinance, and I couldn’t be more pleased with the service I received from Visvesh. He was incredibly professional, knowledgeable, and made the entire process seamless. Visvesh was always available to answer my questions, provided clear explanations, and ensured everything was handled smoothly from start to finish. His attention to detail and commitment to making this experience stress-free truly set him apart. I highly recommend Visvesh to anyone looking for a skilled and dedicated loan officer.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [reviews.length]);

  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % reviews.length);
  };

  const handlePrev = () => {
    setCurrentIndex((currentIndex - 1 + reviews.length) % reviews.length);
  };

  return (
    <div className="OurSatisfiedBoxParent">
      <div className="OurSatisfiedBox">
        {reviews.map((review, index) => (
          <div
            className={`OurSatisfiedContentBox ${
              index === currentIndex ? "active" : "inactive"
            }`}
            key={index}
          >
            <span className="OurSatisfiedStars">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
            </span>
            <span className="OurSatisfiedContent">
              <span className="OurSatisfiedName">{review.contentHeading}</span>
              {review.content}
            </span>
            <span className="OurSatisfiedNameLocation">
              <span className="OurSatisfiedName">{review.name}</span>
              <span className="OurSatisfiedLocation">{review.location}</span>
            </span>
          </div>
        ))}
      </div>
      <span className="OurSatisfiedArrows">
        <i
          className="ri-arrow-left-wide-fill OurSatisfiedLeftArrow"
          onClick={handlePrev}
        ></i>
        <i
          className="ri-arrow-right-wide-fill OurSatisfiedRightArrow"
          onClick={handleNext}
        ></i>
      </span>
    </div>
  );
}

export default ClientReviewVisveshBalasubramanian;
